<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'complex-table-6';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
$border: 2pt solid #c0bec7;
.complex-table-6 {
  td {
    div {
      border-left: $border;
      border-bottom: $border;
    }
    &:last-child {
      div {
        border-right: $border;
      }
    }
  }
  th {
    &:not(.empty) {
      div {
        border-top: $border;
        border-left: $border;
      }
    }
    &.empty {
      div {
        border-top: $border;
      }
    }
    &:last-child {
      div {
        border-right: $border;
      }
    }
    &:first-child {
      div {
        border-left: $border;
      }
    }
  }
  thead {
    tr {
      &:first-child {
        th {
          background-color: var(--theme-color-1-10);
          div {
            border-top: $border;
          }
        }
      }
    }
  }
  tbody {
    tr {
      &:nth-child(even) {
        background-color: var(--theme-color-1-10);
      }
      &:first-child {
        td {
          div {
            border-top: 3pt solid var(--theme-color-1);
          }
        }
      }
      &:last-child {
        td {
          div {
            border-bottom: 3pt solid var(--theme-color-1);
          }
        }
      }
      td {
        &:last-child {
          div {
            border-right: 3pt solid var(--theme-color-1);
          }
        }
        &:first-child {
          background-color: var(--theme-color-1);
          div {
            color: #fff;
          }
        }
        &:nth-child(2) {
          background-color: var(--theme-color-1);
          div {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
